import Icon from 'components/Icon/Icon.component';
import PageScaffolding from 'components/PageScaffolding/PageScaffolding.component';
import colors from 'style-utils/colors';
import media from 'style-utils/media-queries';

import styled from 'styled-components';

export const BonusAmountAvailableHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BonusAmountAvailableHeadingTitle = styled.h1`
  font-family: var(--secondary-font-family), sans-serif;
  margin: 0;
  color: ${colors.black};
  font-weight: 700;
  font-size: 18px;
`;
export const Table = styled.div`
  display: table;
  width: 100%;
  border-collapse: collapse;
  border: none;
  justify-content: space-between;
  ${media.desktop`
    display: flex;
    flex-direction: column;
  `};
`;

export const TableRow = styled.div`
  display: table-row;
  ${media.desktop`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  `};
`;

export const TableCell = styled.div`
  display: flex;
  flex-direction: column;
  ${media.desktop`
  `};
`;

export const TableCellWalletBonus = styled.div`
  display: contents;
  flex-direction: column;
`;

export const TitleBonusCard = styled.h3`
  margin: 0;
  color: var(--Neutral-neutral900, var(--Neutrals-Black-Default, #000));
  font-family: var(--tw-fr-font-display, var(--secondary-font-family));
  font-size: 28px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const RowTitle = styled.h1`
  font-family: var(--primary-font-family), sans-serif;
  font-weight: 600;
  font-size: 16px;
  padding: 0 5px;
  margin-top: 16px;
  margin-bottom: 0;
`;

export const RowParagraph = styled.h1`
  font-family: var(--primary-font-family), sans-serif;
  font-weight: 400;
  font-size: 14px;
  padding: 0 5px;
  margin-top: 4px;
  margin-bottom: 16px;
  line-height: 18px;
`;

export const BoldTableCell = styled(TableCell)`
  font-family: var(--secondary-font-family), sans-serif;
  font-weight: bold;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MobileTableRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: relative;

  ${media.desktop`
    &:first-child {
      padding-top: 0;
    }
  `};

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 5px;
    width: calc(100% - 5px);
    border-bottom: 1px solid lightgray;
  }
`;

export const MobileTable = styled.div`
  display: table;
  width: 100%;
  border-collapse: collapse;
  border: none;
`;

export const RowRightItems = styled.div<{
  $isDropdown?: boolean;
}>`
  display: flex;
  padding-right: ${({ $isDropdown }) => $isDropdown && '5px'};
  ${media.desktop`
    padding-right: ${({ $isDropdown }) => $isDropdown && '0px'};
  `};
`;

export const BonusCardHeaderInfoButton = styled.div`
  height: 21.61px;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 20px;
`;

export const IconAlertCard = styled(Icon)`
  cursor: pointer;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
`;

BonusCardHeaderInfoButton.displayName = 'BonusCardHeaderInfoButton';

////////////////// DROPDOWN //////////////////////

export const DropdownIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 13px;
  padding: 10px 0 0;
`;

export const DropdownBoldTableCell = styled.h1`
  font-family: var(--secondary-font-family), sans-serif;
  font-weight: bold;
  font-size: 14px;
  padding: 5px;
  margin-bottom: 0;
  text-transform: capitalize;
`;

export const DropdownRowTitle = styled.h1`
  font-family: var(--primary-font-family), sans-serif;
  font-weight: 400;
  font-size: 14px;
  padding: 5px;
  margin-bottom: 0;
`;

export const BonusPageScaffolding = styled(PageScaffolding)`
  padding-left: 16px;
  padding-right: 16px;
`;
BonusPageScaffolding.displayName = 'BonusPageScaffolding';
